export default __webpack_public_path__ + "static/media/profileIcon.0d406d7b.svg";